import { TypeResponse } from '@app/shared/enum/TypeResponse';

export class ResponseResult {
    typeResponse: TypeResponse;
    message: string;
    data: any;
    requestTime: number;
}
